import React from 'react'
import { useDeportes } from '../../../hooks/useDeportes'

// Indicador de participacion (spec §4.7): en que deportes participa el jugador
// este ciclo, mas alla de la temporada que se esta gestionando, y a cuales jugaba
// antes. Solo presentacion: lo calcula buildParticipacionByJugador.

const ESTATUS = {
  activo: { label: 'Activo', cls: 'bg-green-100 text-green-700' },
  pendiente: { label: 'Pendiente', cls: 'bg-muted text-muted-foreground' },
}

const ParticipacionBadges = ({ participacion }) => {
  const { label: deporteLabel } = useDeportes()
  const actuales = participacion?.actuales || []
  const anteriores = participacion?.anteriores || []

  if (!actuales.length && !anteriores.length) {
    return <span className="text-xs text-muted-foreground">—</span>
  }

  return (
    <div className="flex flex-wrap items-center gap-1">
      {actuales.map(({ deporteId, estatus }) => {
        const e = ESTATUS[estatus] || ESTATUS.pendiente
        return (
          <span
            key={deporteId}
            className={`inline-flex rounded-full px-2 py-0.5 text-xs font-medium leading-none ${e.cls}`}
          >
            {deporteLabel(deporteId)} · {e.label}
          </span>
        )
      })}
      {anteriores.length > 0 && (
        <span className="text-xs text-muted-foreground">
          Antes: {anteriores.map((d) => deporteLabel(d)).join(', ')}
        </span>
      )}
    </div>
  )
}

export default ParticipacionBadges
